module.exports = __webpack_public_path__ + "img/b2.4ac2869d.png";